import { FC } from "react";
import ProductsList from "../../sections/ProductsList";
import StudioContent from "../../sections/StudioContent";

const General: FC = () => {
  return (
    <>
      <StudioContent />
      <ProductsList />
    </>
  );
};

export default General;
